<template>
    <painel-component :itens="itensOne">

        <row-component>
            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Nome:</label>
                <input-component :type-input="'text'" v-model="formData.name"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Status:</label>
                <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>CNPJ:</label>
                <input-component v-mask="'##.###.###/####-##'" :type-input="'text'" v-model="formData.cnpj"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>CPF:</label>
                <input-component v-mask="'###.###.###-##'" :type-input="'text'" v-model="formData.cpf"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'">
                <button-submit @submit="submit" :items="buttonSubmit" class="me-2"/>
                <button-route v-if="buttonCheck.create" :items="buttonRoute"/>
            </row-col-component>
        </row-component>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 30%">Nome</th>
                <th scope="col" style="width: 20%">Status</th>
                <th scope="col" style="width: 30%">CPF / CNPJ</th>
                <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit">
                    Ações
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(provider, index) in provider.data" :key="index">
                <td data-label="Nome">
                    <img v-if="provider.photo" class="avatar__image mx-1" :src="provider.photo" alt="">
                    <img v-else class="avatar__image mx-1" src="@/assets/images/avatar.png" alt="">
                    {{ provider.name }}
                </td>
                <td data-label="Status">{{ statusString(provider.status) }}</td>
                <td data-label="CPF / CNPJ">{{ provider.cpf }} {{ provider.cnpj }}</td>
                <td data-label="Ações">
                    <button-edit v-if="buttonCheck.edit" :route="'provider-edit'" :id-param="provider.id"/>
                    <button-show v-if="buttonCheck.show" :route="'provider-show'" :id-param="provider.id"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="provider" :offset="3" @paginate="loadProviders"/>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonShow from '@/components/buttons/ButtonShow';
import {useToast} from "vue-toastification";
import {mask} from 'vue-the-mask'
import ButtonPagination from "@/components/buttons/ButtonPagination.vue";

const toast = useToast()

export default {
    name: 'ProviderSearch',

    created() {
        this.$store.dispatch('updateNamePage', 'Fornecedor')
        this.checkACL()
        this.loadProviders(1)
    },

    components: {
        ButtonPagination,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        ButtonEdit,
        ButtonShow
    },

    directives: {
        mask
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            buttonSubmit: {
                icon: 'ti-search',
            },

            buttonRoute: {
                icon: 'ti-plus',
                route: '/provider/create'
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formData: {
                name: '',
                cnpj: '',
                cpf: '',
                status: ''
            },

            searchSubmit: false,
        }
    },

    methods: {

        submit() {
            this.loadProviders(1)
            this.searchSubmit = true
        },

        statusString(value) {
            if (value === '1')
                return 'Ativo'
            return 'Inativo'
        },

        loadProviders(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadProviders', {...this.params, page})
                    .then((r) => {
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 3)
                .then((r) => {
                    if (r.data.indexOf('provider-search') !== -1) {

                        if (r.data.indexOf('provider-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('provider-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('provider-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        provider() {
            return this.$store.state.provider.items
        },

        params() {
            return {
                page: this.provider.current_page,
                name: this.formData.name,
                cnpj: this.formData.cnpj,
                cpf: this.formData.cpf,
                status: this.formData.status
            }
        },
    }

}
</script>

<style src="@/assets/style/table.css">

</style>

<style scoped>
.avatar__image {
    width: 25px;
}
</style>
